import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  useFormContext,
  Field,
  getInvestmentDurationOptions,
  getInvestmentObjectiveOptions,
  getPlannedServicesOptions,
  isOtherInvestmentObjective,
  isOtherPlannedService,
} from '../../../../forms/investmentPurposeAndNatureForm';

export const FormContent = () => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  return (
    <GridFields>
      <Field.Autocomplete
        fullWidth
        multiple
        showRequiredMark
        label={t(
          'client.legal.investmentPurposeAndNature.plannedServices.label'
        )}
        name="investmentPurposeAndNature.plannedServices"
        optionLabelKey="label"
        options={getPlannedServicesOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'client.legal.investmentPurposeAndNature.plannedServices.placeholder'
        )}
        variant="select"
      />

      {isOtherPlannedService(
        values.investmentPurposeAndNature.plannedServices
      ) && (
        <Field.Text
          fullWidth
          showRequiredMark
          label={t(
            'client.legal.investmentPurposeAndNature.otherPlannedServices.label'
          )}
          name="investmentPurposeAndNature.otherPlannedServices"
          placeholder={t(
            'client.legal.investmentPurposeAndNature.otherPlannedServices.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t(
          'client.legal.investmentPurposeAndNature.investmentDuration.label'
        )}
        name="investmentPurposeAndNature.investmentDuration"
        optionLabelKey="label"
        options={getInvestmentDurationOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'client.legal.investmentPurposeAndNature.investmentDuration.placeholder'
        )}
        variant="select"
      />

      <Field.Autocomplete
        fullWidth
        multiple
        showRequiredMark
        label={t(
          'client.legal.investmentPurposeAndNature.investmentObjectives.label'
        )}
        name="investmentPurposeAndNature.investmentObjectives"
        optionLabelKey="label"
        options={getInvestmentObjectiveOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'client.legal.investmentPurposeAndNature.investmentObjectives.placeholder'
        )}
        variant="select"
      />

      {isOtherInvestmentObjective(
        values.investmentPurposeAndNature.investmentObjectives
      ) && (
        <Field.Text
          fullWidth
          showRequiredMark
          label={t(
            'client.legal.investmentPurposeAndNature.otherInvestmentObjective.label'
          )}
          name="investmentPurposeAndNature.otherInvestmentObjective"
          placeholder={t(
            'client.legal.investmentPurposeAndNature.otherInvestmentObjective.placeholder'
          )}
        />
      )}
    </GridFields>
  );
};
